import {Fragment} from 'react';
import {Paper, Avatar, Typography, Grid, Button, IconButton} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import {getFirstCharacter} from '../../shared/components/CustomAvatar';
import {makeStyles} from '@material-ui/core/styles';
import {blue, green, orange, red} from '@material-ui/core/colors';
import {Tooltip} from 'antd';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import {useState} from 'react';
import VendorsDetails from './VendorsDetails';
import {Alert} from '@material-ui/lab'
import useNotificationDialog from '../../shared/components/useNotificationDialog';
import {firestore} from '../../config/firebaseConfig';
import {toast} from 'react-toastify';
import VendorEditionModal from "./VendorEditionModal";

const useStyles = makeStyles((theme) => ({
    primary: {
        color: theme.palette.getContrastText(blue[500]),
        backgroundColor: blue[500],
    },
    info: {
        color: theme.palette.getContrastText(blue[200]),
        backgroundColor: blue[200],
    },
    success: {
        color: theme.palette.getContrastText(green[400]),
        backgroundColor: green[400],
    },
    warning: {
        color: theme.palette.getContrastText(orange[200]),
        backgroundColor: orange[200],
    },
    error: {
        color: theme.palette.getContrastText(red[300]),
        backgroundColor: red[300],
    },

}));

const PRIMARY_NAME = ['A', 'N', 'H', 'L', 'Q', '9', '8'];
const INFO_NAME = ['F', 'G', 'T', 'I', 'J', '1', '2', '3'];
const SUCCESS_NAME = ['K', 'D', 'Y', 'B', 'O', '4', '5'];
const WARNING_NAME = ['P', 'E', 'R', 'S', 'C', 'U', '6', '7'];
const ERROR_NAME = ['V', 'W', 'X', 'M', 'Z'];


export default function VendorCard({vendor, action}) {
    const {Name: name} = vendor;
    const logo = name;
    const classes = useStyles();
    const [modalState, setModalState] = useState(false);
    const [modal2State, setModal2State] = useState(false);
    const {open, ShowNotificationDialog, handleOpen, handleClose} = useNotificationDialog()

    const handleCancel = () => {
        setModalState(false);
    }

    const handleEdit = () => {
        setModalState(true);
    }
    const handle2Cancel = () => {
        setModal2State(false);
    }

    const handle2Open = () => {
        setModal2State(true);
    }

    const handleDelete = () => {
        firestore.collection('vendors').doc(vendor.id).delete().then(() => {
            toast.success("success")
            handleClose()
        }).catch((error) => {
            toast.error("error");
        });
        ;
    }


    const getAvatarColor = (name) => {
        if (PRIMARY_NAME.includes(getFirstCharacter(name))) return classes.primary;
        if (INFO_NAME.includes(getFirstCharacter(name))) return classes.info;
        if (SUCCESS_NAME.includes(getFirstCharacter(name))) return classes.success;
        if (WARNING_NAME.includes(getFirstCharacter(name))) return classes.warning;
        if (ERROR_NAME.includes(getFirstCharacter(name))) return classes.error;
        return 'default';
    }


    return (
        <>

            <Paper elevation={4} style={{width: '100%',  minWidth:5 , marginTop: 10}}>
                <Grid container justify="space-between" spacing={2}>
                    <Grid container item xs={9} spacing={2} alignItems="center">

                        <Grid item style={{marginLeft: 15}}>
                            <Tooltip title={
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <IconButton size="small" color="secondary" onClick={handleOpen}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <IconButton size="small" color="primary" onClick={handleEdit}>
                                            <EditIcon/>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            }>
                                <Avatar variant="rounded" src={logo} alt={name} className={getAvatarColor(name)}>
                                    {getFirstCharacter(name)}
                                </Avatar>
                            </Tooltip>
                        </Grid>

                        <Grid item style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            width: '70%'
                        }}>
                            <Tooltip title={
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <IconButton size="small" color="secondary" onClick={handleOpen}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </Grid>
                                    <Grid item>
                                        <IconButton size="small" color="primary" onClick={handleEdit}>
                                            <EditIcon/>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            }>
                                <Typography variant="overline">
                                    {name}
                                </Typography>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    {modal2State &&
                    <VendorsDetails visible={modal2State} handle2Cancel={handle2Cancel} vendor={vendor}/>}
                    <Grid container item xs={3} alignContent='center' style={{marginRight: 10}}>
                        <Grid item>
                            <Button size="small"
                                    variant="outlined"
                                    color="primary"
                                    onClick={handle2Open}
                            >
                                Ouvrir
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>

            {
                <VendorEditionModal show={modalState} onClose={handleCancel} vendor={vendor}/>
            }

            {
                open && (
                    <ShowNotificationDialog title="SUPPRIMER"
                                            action={
                                                <Fragment>
                                                    <Button color="primary" onClick={handleClose}> Annuler </Button>

                                                    <Button color="secondary" onClick={handleDelete}>
                                                        J'accepte Supprimer
                                                    </Button>
                                                </Fragment>
                                            }>
                        <Alert severity="error"> Vous êtes sur le point de supprimer le vendor et les stores </Alert>
                    </ShowNotificationDialog>
                )
            }
        </>
    )
}


export const VendorCardSkeleton = () => {


    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rect" width="100%" height="40"/>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rect" width="100%" height="40"/>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rect" width="100%" height="40"/>
            </Grid>
        </Grid>
    );
}